// Copyright: IQGeo Limited 2010-2019
import myw from 'myWorld/base/core';
import './fieldEditor';
import $ from 'jquery';

/**
 * Input for fields of type reference. <br/>
 * Disabled text input with a clear button
 * @name ReferenceFieldEditor
 * @constructor
 * @extends {FieldEditor}
 */
myw.ReferenceFieldEditor = myw.FieldEditor.extend({
    className: 'text disabled-input',
    attributes: { disabled: 'true' },

    events: {
        'click #reference-field-clear': 'reset'
    },

    initialize(owner, feature, fieldDD, options) {
        myw.FieldEditor.prototype.initialize.call(this, owner, feature, fieldDD, options);

        const container = $('<div>', { id: 'related-field-container' });

        //Disabled input field
        this.control = new myw.Input({
            value: this.fieldValue,
            cssClass: 'disabled-input',
            disabled: 'disabled'
        });

        // Add input field to container
        container.append(this.control.$el);

        //if reference field add the clear button to the container
        if (fieldDD.type == 'reference') {
            this._clearButton = $('<img>', {
                id: 'reference-field-clear',
                src: myw.baseUrl + 'images/x_extra_small.png'
            });
            container.append(this._clearButton);
        }

        this.setElement(container);

        //enable firing 'change' event
        this.control.$el.on('input', this._changed.bind(this));
    },

    convertValueForDisplay(fieldValue) {
        const fieldDD = this.fieldDD,
            displayValues = this.feature.displayValues;

        if (displayValues && displayValues[fieldDD.internal_name]) {
            fieldValue = displayValues[fieldDD.internal_name];
        }
        return fieldValue;
    },

    getValue() {
        //value not set in UI but could have been set internally
        const value = this.feature.properties[this.fieldDD.internal_name];
        if (value === undefined || value === null) {
            //no urn(s) have been specified, don't include this field in the json sent to the server
            return undefined;
        }
        return value;
    },

    /**
     * Returns true since we don't provide the user a way to set a reference feature.
     * which means we don't need to validate it.
     * @return {boolean}  True
     */
    validate(value) {
        return true;
    },

    /**
     * Sets value internally (not in UI)
     * @param {obj} value
     */
    setInternalValue(value) {
        this.feature.properties[this.fieldDD.internal_name] = value;
    },

    /**
     * Sets related to field to null on clear button click
     */
    reset() {
        this.setInternalValue(null);
        this.setValue(null); //sets display value
    }
});

export default myw.ReferenceFieldEditor;
